import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import { GlobalConstants } from '../../common/global-constants';
import * as ngswal from "sweetalert";
declare var $;
import { DomSanitizer } from "@angular/platform-browser";


@Component({
  selector: 'app-manuscript',
  templateUrl: './manuscript.component.html',
  styleUrls: ['./manuscript.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
/** manuscript component*/
export class ManuscriptComponent implements OnInit {
  showModal: boolean;
  uploadTypeList: any;
  fileBase64: string = "";

  constructor(private sanitizer: DomSanitizer) { }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  fileChangeEvent(fileInput: any) {
    var ext = $('#FU_Attchment').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['zip']) == -1) {
      $('#FU_Attchment').val("");
      ngswal("Failed !", "Please Upload zip File format !", "warning");
      return false;
    }
    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  ngOnInit() {
    $('#divitemList').css('height', GlobalConstants.size.height - 150);
    this.GetApiList();
    this.LoadDataList();

    //setInterval(function () {
    //  $('#btnLoadData').trigger("click");
    //}, 10000);
  }

  public LoadDataList() {
    let dataEmpty = '<h3 style="height: 100px; line-height: 100px; text-align: center;"> No data found !</h3>';

    var dataitem = {
      FilterText: $('#txtQuickSearch').val(),
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };
    ApiMethod.postMethod("api/meslist", dataitem).subscribe(
      resonse => {

        let itemList = resonse.dataitem;

        let htmlData = '<div class="row">';
        let refNo = '';
        $.each(itemList, function (e, val) {
          let leftDiv = ''; let rightDiv = '';
          let styleDetails = 'style="color:#3649d5;cursor:pointer;"';
          if (refNo != val.RefNo) {
            leftDiv += '<div><strong>' + 'ReferenceNo : ' + val.RefNo + '</strong></div>';
            leftDiv += '<div><strong>' + 'Method : ' + val.ApiName + '</strong></div>';
            leftDiv += '<div ' + styleDetails + ' onclick=localStorage.refNo="' + val.RefNo + '";localStorage.reftype="FromNt";$("#btnDownload").trigger("click");>' + 'Upload Package : ' + val.UploadPackage + '</div>';
            leftDiv += '<div>' + 'Upload Date : ' + val.UploadDate + '</div>';
          }
          else {
            leftDiv += '';
          }

          rightDiv += '<div>' + 'CreatedOn : ' + GlobalConstants.isNullCheck(val.ReturnDateOn) + '</div>';
          if (GlobalConstants.isNullCheck(val.ReturnStatus) != '') {
            rightDiv += '<div>' + 'Status : ' + val.ReturnStatus + '</div>';
          }
          if (GlobalConstants.isNullCheck(val.ManuscriptLink) != '') {
            rightDiv += '<div>' + 'Manuscript Link : <a href="' + val.ManuscriptLink + '" target="_blank">' + val.ManuscriptLink + '</a></div>';
          }
          if (GlobalConstants.isNullCheck(val.EditorLink) != '') {
            rightDiv += '<div>' + 'Editor Link : <a href="' + val.EditorLink + '" target="_blank">' + val.EditorLink + '</a></div>';
          }
          if (GlobalConstants.isNullCheck(val.ReturnPackage) != '') {
            rightDiv += '<div ' + styleDetails + ' onclick=localStorage.refNo="' + val.RefNo + '";localStorage.reftype="ToNt";$("#btnDownload").trigger("click");>' + 'Return Package : ' + val.ReturnPackage + '</div>';
          }
          if (GlobalConstants.isNullCheck(val.ReceivedDate) != '') {
            rightDiv += '<div>' + 'Status Received: ' + val.ReceivedDate + '</div>';
          }
          if (GlobalConstants.isNullCheck(val.StatusDuration) != '') {
            rightDiv += '<div>' + 'Status Duration: ' + val.StatusDuration + '</div>';
          }
          if (GlobalConstants.isNullCheck(val.Message) != '') {
            rightDiv += '<div>' + 'Message : ' + val.Message + '</div>';
          }
          rightDiv += '<hr/>';

          refNo = val.RefNo;

          //htmlData += '<div class="col-4">' + leftDiv + '</div>';
          //htmlData += '<div class="col-8">' + rightDiv + '</hr></div>';

          htmlData += '<br/><table><tr>';
          htmlData += '<td style="width:30pc;vertical-align:top;">' + leftDiv + '</td>';
          htmlData += '<td>' + rightDiv + '</td>';
          htmlData += '</tr></table>';

        });
        htmlData += '</div>';


        if (itemList.length == 0) {
          htmlData = dataEmpty;
        }
        $('#divitemList').html(htmlData);

      },
      error => {
        console.error(error)

      }
    );

  }

  public GetApiList() {
    ApiMethod.getMethod("api/icodexapilist").subscribe(
      resonse => {
        this.uploadTypeList = resonse.dataitem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      })
  }

  public Download() {
    ApiMethod.Downloadfile('api/mespackage/' + localStorage.refNo + '/' + localStorage.reftype);
  }


  public UploadMethod() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_Attchment')).files;
    if ($('#ddlUploadType').val() == 0) {
      ngswal("Warning !", "Please Upload Method type!", "warning");
    }
    else if (idInput.length == 0) {
      ngswal("Warning !", "Select package!", "warning");
    }
    else {
      $('#LoadingImage').show();
      var dataitem = {
        PublisherId: localStorage.aPubID,
        ApiName: $('#ddlUploadType').val(),
        UploadPackageBase64: this.fileBase64,
        UploadPackage: idInput[0].name
      };
      ApiMethod.postMethod("api/nt2icodex", dataitem).subscribe(resonse => {
        console.log(resonse);
        $('#LoadingImage').hide();
      });
      ngswal("Uploaded !", "File Ingestion Successfully...!", "info");
      this.Reset();
      $('#LoadingImage').hide();
    }
  }

  Reset() {
    $('#ddlUploadType').val(0).change();
    $('#FU_Attchment').val("");
    this.LoadDataList();
  }
}
